import * as type from './friendProfileActionType';

// for friendStats
export const setFriendStatsAction = (friendStatsData) => ({
  type: type.SET_FRIEND_STATS,
  friendStatsData,
});

export const getFriendStatsAction = () => ({
  type: type.GET_FRIEND_STATS,
});

// for friendActivity
export const setFriendActivityAction = (friendActivityData) => ({
  type: type.SET_FRIEND_ACTIVITY,
  friendActivityData,
});
export const getFriendActivityAction = (timePeriod) => ({
  type: type.GET_FRIEND_ACTIVITY,
  timePeriod,
});

// for friendBadges
export const getFriendBadgesAction = (skip, limit) => ({
  type: type.GET_FRIEND_BADGES,
  skip,
  limit,
});

export const setFriendBadgesAction = (friendBadges) => ({
  type: type.SET_FRIEND_BADGES,
  friendBadges,
});

export const setIsLoadingFriendBadgesAction = (isLoadingBadges) => ({
  type: type.SET_IS_LOADING_FRIEND_BADGES,
  isLoadingBadges,
});

// for friend scoring History

export const setFriendScoringHistoryAction = (friendScoringHistoryData) => ({
  type: type.SET_FRIEND_SCORING_HISTORY,
  friendScoringHistoryData,
});
export const getFriendScoringHistoryAction = (timePeriod) => ({
  type: type.GET_FRIEND_SCORING_HISTORY,
  timePeriod,
});

// for friend header

export const setFriendHeaderAction = (friendHeaderData) => ({
  type: type.SET_FRIEND_HEADER,
  friendHeaderData,
});
export const getFriendHeaderAction = () => ({
  type: type.GET_FRIEND_HEADER,
});

// for friend profile
export const setFriendProfileAction = (friendProfile) => ({
  type: type.SET_FRIEND_PROFILE,
  friendProfile,
});
export const getFriendProfileAction = () => ({
  type: type.GET_FRIEND_PROFILE,
});
